// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dRrj","name":"styles_name__8S0dG","phone":"styles_phone__3AFe1"};